import { apiClient } from './api';

/**
 * REV-217 client: CRUD for advisory notes on FindingInstances.
 *
 * Read: any org member (viewers included).
 * Write: any org member (viewers included) can create; edit/delete is
 * author-or-manager-only.
 */
export type AdvisoryNotePriority = 'critical' | 'high' | 'normal' | 'low';

export interface AdvisoryNoteAuthor {
  id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
}

export interface AdvisoryNote {
  id: string;
  finding_instance_id: string;
  organization_id: string;
  author_user_id: string;
  body: string;
  priority: AdvisoryNotePriority | null;
  created_at: string;
  updated_at: string;
  author?: AdvisoryNoteAuthor | null;
}

export const advisoryNoteService = {
  async list(orgId: string, findingId: string): Promise<AdvisoryNote[]> {
    const res = await apiClient.get<{ success: boolean; data: AdvisoryNote[] }>(
      `/v1/organizations/${orgId}/finding-instances/${findingId}/advisory-notes`
    );
    return res.data;
  },

  async create(
    orgId: string,
    findingId: string,
    data: { body: string; priority?: AdvisoryNotePriority | null }
  ): Promise<AdvisoryNote> {
    const res = await apiClient.post<{ success: boolean; data: AdvisoryNote }>(
      `/v1/organizations/${orgId}/finding-instances/${findingId}/advisory-notes`,
      data
    );
    return res.data;
  },

  async update(
    orgId: string,
    noteId: string,
    data: { body?: string; priority?: AdvisoryNotePriority | null }
  ): Promise<AdvisoryNote> {
    const res = await apiClient.patch<{ success: boolean; data: AdvisoryNote }>(
      `/v1/organizations/${orgId}/advisory-notes/${noteId}`,
      data
    );
    return res.data;
  },

  async delete(orgId: string, noteId: string): Promise<void> {
    await apiClient.delete<{ success: boolean }>(
      `/v1/organizations/${orgId}/advisory-notes/${noteId}`
    );
  },
};
